/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

import AppConst from '../../constants/app.constant';
import ChartConst from '../../constants/chart.constant';
import d3 from '../../globalexports/d3.export';
import utilityService from '../../services/utility.service';
import bnChartDataService from '../../services/chartData.service';
import bnChartDataProcessService from '../../services/chartDataProcess.service';
import routeProfileService from '../Routeprofile/Routeprofile.service';
import gridViewDataSource from './Gridview.data';

function gridViewService() {
  const content = {};
  const gridViewDataMapKey = d3.timeFormat(ChartConst.mapKeyCreator);
  let gridViewDataMap = {};

  function getIndexesForGrid(travelStart, travelEnd, refAirport, recordsMax) {
    const travelStartObj = bnChartDataService.findClosestRecord(refAirport, travelStart);
    const travelEndObj = bnChartDataService.findClosestRecord(refAirport, travelEnd);
    let leftEdge;
    let rightEdge;
    let i = 0;
    let leftSideAvailable;
    let rightSideAvailable;
    let minRecordRequired = AppConst.webGridColumnMin;
    if (utilityService.getOrientation() === ChartConst.orientation.portrait) {
      minRecordRequired = AppConst.mobileGridColumnMin;
    }
    if (recordsMax > minRecordRequired) {
      minRecordRequired = recordsMax;
    }
    leftEdge = travelStartObj.closestMetaData.index;
    rightEdge = travelEndObj.closestMetaData.index;
    while (i < minRecordRequired) {
      leftSideAvailable = (leftEdge > 0);
      rightSideAvailable = (rightEdge < refAirport.forecast.length - 1);
      if (((rightEdge - leftEdge) + 1) < minRecordRequired && leftSideAvailable) {
        leftEdge -= 1;
      }
      if (((rightEdge - leftEdge) + 1) < minRecordRequired && rightSideAvailable) {
        rightEdge += 1;
      }
      i += 1;
    }
    return {
      start: leftEdge,
      end: rightEdge,
    };
  }
  content.getGridViewData = (
    travelRoute,
    fullDataOriginal,
    departureTime,
    recordsMax,
  ) => {
    let i;
    let j;

    if (travelRoute === null || travelRoute === undefined) {
      return null;
    }
    if (gridViewDataMap[gridViewDataMapKey(departureTime)]) {
      // if value exist in map
      return gridViewDataMap[gridViewDataMapKey(departureTime)];
    }
    const fullDataCopy = utilityService.clone(fullDataOriginal);
    const travelStart = travelRoute[0].arrival_time;
    const travelEnd = travelRoute[travelRoute.length - 1].arrival_time;
    i = 0;
    const sliceMap = getIndexesForGrid(travelStart, travelEnd, fullDataOriginal[0], recordsMax);
    if (!recordsMax) {
      if (sliceMap.start === 0) {
        sliceMap.end += 1;
      } else {
        sliceMap.start -= 1;
      }
    }
    while (i < fullDataCopy.length) {
      fullDataCopy[i].forecast = fullDataOriginal[i].forecast.slice(sliceMap.start, sliceMap
        .end + 1);
      // }
      j = 0;
      while (j < fullDataCopy[i].forecast.length) {
        fullDataCopy[i].forecast[j].sunMoonPositionData = utilityService.getSunMoonCalculation(
          fullDataCopy[i].forecast[j].forecast_ts_local,
          fullDataCopy[i].forecast[j].lat,
          fullDataCopy[i].forecast[j].lng,
        );
        bnChartDataProcessService.appendWeatherStripData(
          fullDataCopy[i].forecast[j],
          'forecast_ts_local',
        );
        j += 1;
      }
      i += 1;
    }
    gridViewDataMap[gridViewDataMapKey(departureTime)] = fullDataCopy;
    return fullDataCopy;
  };

  function deletePropertiesNotNeeded(fullDataRef) {
    delete fullDataRef.travelRoute;
    delete fullDataRef.totalFlightDuration;
    delete fullDataRef.gairmet;
    delete fullDataRef.mavEndsAt;
    delete fullDataRef.lampStartAt;
    delete fullDataRef.airportSequence;
    delete fullDataRef.bnforecastAllMets;
    delete fullDataRef.elevationData;
    delete fullDataRef.airsigmet;
    delete fullDataRef.gridDataObject;
    delete fullDataRef.flightMode;
    delete fullDataRef.waitForAloft;
  }
  content.buildGridViewMap = (settings, sliderMainObj, applicationSettings, fullData) => {
    let i = 0;
    let travelRoute;
    let fullDataRef = utilityService.clone(fullData);
    deletePropertiesNotNeeded(fullDataRef);
    const lampData = utilityService.clone(gridViewDataSource.fullData.lamp);
    const mavData = utilityService.clone(gridViewDataSource.fullData.mav);
    deletePropertiesNotNeeded(lampData);
    deletePropertiesNotNeeded(mavData);
    let flightMode;
    let recordsMax;
    let record;
    while (i < sliderMainObj.length) {
      flightMode = bnChartDataService.isMavOrLampFlight(sliderMainObj[i], fullData
        .totalFlightDuration);
      if (flightMode === ChartConst.products.lamp.name) {
        fullDataRef = lampData;
      } else if (flightMode === ChartConst.products.mav.name) {
        fullDataRef = mavData;
      }
      travelRoute = routeProfileService.getTravelRoute(sliderMainObj[i], settings);
      record = content.getGridViewData(travelRoute, fullDataRef, sliderMainObj[i], recordsMax);
      if (!recordsMax && record) {
        recordsMax = record[0].forecast.length;
      }
      i += 1;
    }
  };
  content.getDataByKey = (departureTime) => {
    if (gridViewDataMap[gridViewDataMapKey(departureTime)]) {
      // if value exist in map
      return gridViewDataMap[gridViewDataMapKey(departureTime)];
    }
    return 'Not loaded yet';
  };
  content.getGridViewDataMap = () => gridViewDataMap;
  content.cleanMap = () => {
    gridViewDataMap = {};
  };
  return content;
}
export default gridViewService();
